module.exports = new __parcel__URL__("waynes-world.8ad8d9bb.jpg").toString();